<template>
  <p id="cast-icon-circle" :class="classes" v-if="image_url">
    <img
      :width="width"
      :height="height"
      class="ml-2"
      :src="_GetImagePath(image_url)"
      v-if="image_url"
    />
  </p>
  <p v-else class="noImage ml-2">
    {{ firstWord }}
  </p>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: "",
    },
    image_url: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "40",
    },
    height: {
      type: String,
      default: "40",
    },
    classes: {
      type: String,
      default: "",
    },
  },
  computed: {
    firstWord() {
      let letter = this.name.charAt(0);
      return letter;
    },
  },
};
</script>

<style>
#cast-icon-circle {
  border-radius: 50%;
  margin-right: 5px;
}

#cast-icon-circle img {
  border-radius: 50%;
}

.noImage {
  border-radius: 50%;
  background: #e9ecef;
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
  color: var(--primary);
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/CastIcon.vue